import { Component, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button-renderer',
  template: `
    <div *ngIf="!params.node.group" (click)="openDialog($event)">
      <svg style="width:18px;height:18px" viewBox="0 0 18 18">
        <path stroke="null" id="svg_1" d="m5.49302,0.254968l0,0.863758l-4.318788,0l0,1.727515l0.863758,0l0,11.228849a1.727515,1.727515 0 0 0 1.727515,1.727515l8.637576,0a1.727515,1.727515 0 0 0 1.727515,-1.727515l0,-11.228849l0.863758,0l0,-1.727515l-4.318788,0l0,-0.863758l-5.182546,0m-1.727515,2.591273l8.637576,0l0,11.228849l-8.637576,0l0,-11.228849m1.727515,1.727515l0,7.773818l1.727515,0l0,-7.773818l-1.727515,0m3.45503,0l0,7.773818l1.727515,0l0,-7.773818l-1.727515,0z"/>
      </svg>
    </div>
    `
})

export class ButtonRendererComponent implements ICellRendererAngularComp {
  params;
  label: string;

  constructor(public dialog: MatDialog) {}

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  openDialog($event): void {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      width: '550px',
      data: {
        title: 'Confirm Item Deletion',
        message: `You sure sure you want to delete ${this.params.node.data.part_number}?`,
        yes: 'Delete',
        no: 'Cancel',
        identifier: this.params.node.data.part_number
      }        
    });

    dialogRef.afterClosed().subscribe(result => {
      if (this.params.onClick instanceof Function && result!==undefined) {
        const params = {
          event: $event,
          rowNode: this.params.node,
          rowIndex: this.params.rowIndex,
        }
        this.params.onClick(params);
  
      }
    });
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowNode: this.params.node,
        rowIndex: this.params.rowIndex,
      }
      this.params.onClick(params);

    }
  }
}

@Component({
  selector: 'confirmation-dialog',
  template: `
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div mat-dialog-content>
    <p>{{data.message}}</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="data.identifier" cdkFocusInitial>{{data.yes}}</button>
    <button mat-button (click)="onNoClick()">{{data.no}}</button>
  </div>  
    `
})
export class ConfirmationDialog {

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
